import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgotPassword() {
  const [data, setData] = useState({
    whatsappNo: "",
    oldPassword: "",
    newPassword: ""
  });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [timer, setTimer] = useState(null);

  // Check if the rate limit was previously hit and if time has passed
  useEffect(() => {
    const lockTime = localStorage.getItem('lockTime');
    if (lockTime) {
      const timeElapsed = Date.now() - lockTime;
      if (timeElapsed < 900000) { // 15 minutes in milliseconds
        setIsSubmitDisabled(true);
        startTimer(900000 - timeElapsed); // Set the timer with the remaining time
      } else {
        localStorage.removeItem('lockTime');
      }
    }
  }, []);

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const startTimer = (duration) => {
    setIsSubmitDisabled(true);
    setTimer(setTimeout(() => {
      setIsSubmitDisabled(false);
      localStorage.removeItem('lockTime');
    }, duration));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/resetPassword`, data);
      
      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.status === 429) {
        // Rate limiting response
        toast.error("Too many attempts. Please try after 15 minutes.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });

        // Save lock time in localStorage
        localStorage.setItem('lockTime', Date.now());

        // Disable the submit button and start the timer
        startTimer(900000); // 15 minutes in milliseconds
      } else {
        toast.error("You've provided an invalid password", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    }
  };

  useEffect(() => {
    return () => clearTimeout(timer); // Clear the timer when the component unmounts
  }, [timer]);

  return (
    <div>
      <Navbar />
      <div className="container d-flex justify-content-center align-items-center vh-50">
        <form className="form-group w-50 mt-5 mb-5" onSubmit={handleSubmit}>
          <label htmlFor="whatsappNo">WhatsApp Number</label>
          <input
            type="tel"
            pattern="(\+?[0-9]{1,4})?[0-9]{10,14}"
            title="Please enter WhatsApp number."
            name="whatsappNo"
            id="whatsappNo"
            className="form-control mb-2"
            placeholder="+91XXXXXXXXXX"
            onChange={handleChange}
            required
            disabled={isSubmitDisabled} // Disable input during lockout period
          />
          <label htmlFor="oldPassword">Password you used when signing up</label>
          <input
            type="password"
            minLength="8"
            name="oldPassword"
            id="oldPassword"
            className="form-control mb-2"
            placeholder="Enter first password"
            onChange={handleChange}
            required
            disabled={isSubmitDisabled} // Disable input during lockout period
          />
          <label htmlFor="newPassword">New Password</label>
          <input
            type="password"
            name="newPassword"
            id="newPassword"
            minLength="8"
            className="form-control mb-2"
            placeholder="Type your new password"
            onChange={handleChange}
            required
            disabled={isSubmitDisabled} // Disable input during lockout period
          />
          <div className="justify-content-center d-flex">
            <button
              type="submit"
              className=" btn btn-success btn-sm rounded-pill px-5 py-3 mt-4 mb-4 shadow"
              disabled={isSubmitDisabled} // Disable button during lockout period
            >
              {isSubmitDisabled ? 'Try again in 15 minutes' : 'Confirm Password'}
            </button>
          </div>
        </form>
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
}
